/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  IndexRoute,
  Route,
  Router,
} from 'react-router';
import config from 'loracfg';
import App from '../App';
import AuthLatch from '../AuthLatch';
import ExpireLatch from '../ExpireLatch';
import ActivationLatch from '../ActivationLatch';
import Overview from '../Overview';
import Redirect from '../Redirect';
import NotFound from '../NotFound';
import AccountCenter from '../AccountCenter';
import InfoView from '../AccountCenter/coms/InfoView';
import ManageView from '../AccountCenter/coms/ManageView';
import SecurityView from '../AccountCenter/coms/SecurityView';
import GatewayRoutes from './GatewayRoutes';
import AppRoutes from './AppRoutes';
import BillingRoutes from './BillingRoutes';
import NetworkRoutes from './NetworkRoutes';
import RegisterRoutes from './RegisterRoutes';
import LoginRoutes from './LoginRoutes';


let routes = (
  <Route path="/" component={App}>
    <IndexRoute component={Redirect} />
    <Route component={AuthLatch}>
      <Route component={ExpireLatch}>
        <IndexRoute component={Overview} />
        <Route path="overview" component={Overview} />
        {GatewayRoutes}
        {AppRoutes}
        {NetworkRoutes}
        <Route path="accountcenter" component={AccountCenter}>
          <IndexRoute component={InfoView} />
          <Route path="info" component={InfoView} />
          <Route path="security" component={SecurityView} />
          <Route path="token" component={ManageView} />
        </Route>
      </Route>
      {BillingRoutes}
    </Route>
    {LoginRoutes}
    {RegisterRoutes}
    <Route path="*" component={NotFound} status={404} />
  </Route>
);

if (config.profile === 'cube') {
  routes = (
    <Route component={ActivationLatch}>
      {routes}
    </Route>
  );
}

const propTypes = {
  history: React.PropTypes.any.isRequired,
};

const Routes = (props) => {
  const { history } = props;
  return (
    <Router history={history} routes={routes} />
  );
};

Routes.propTypes = propTypes;

export default Routes;




// WEBPACK FOOTER //
// ./src/containers/Routes/index.jsx